import { getAccessToken } from '../../../storage/auth'

export class Socket {
  constructor(server, endpoint, onOpen, onMessage, onClose, onError) {
    this._server = server
    this._endpoint = endpoint
    this._onOpen = onOpen
    this._onMessage = onMessage
    this._onClose = onClose
    this._onError = onError

    this._ws = null
  }

  connectAsync(caller) {
    let accessToken = getAccessToken()

    return new Promise(resolve => {
      let path = `${this._server}/${this._endpoint}?auth=${accessToken}`

      this._ws = new WebSocket(path)

      this._ws.onopen = () => {
        resolve()
        this._onOpen && this._onOpen.call(caller)
      }

      this._ws.onmessage = async msg => {
        if (this._onMessage) {
          let event = JSON.parse(msg.data)
          await this._onMessage.call(caller, event)
        }
      }

      this._ws.onclose = () => {
        this._onClose && this._onClose.call(caller)
      }

      this._ws.onerror = () => {
        this._onError && this._onError.call(caller)
      }
    })
  }

  connect(caller) {
    let accessToken = getAccessToken()

    let path = `${this._server}/${this._endpoint}?auth=${accessToken}`

    this._ws = new WebSocket(path)

    this._ws.onopen = () => {
      this._onOpen && this._onOpen.call(caller)
    }

    this._ws.onmessage = async msg => {
      if (this._onMessage) {
        let event = JSON.parse(msg.data)
        await this._onMessage.call(caller, event)
      }
    }

    this._ws.onclose = () => {
      this._onClose && this._onClose.call(caller)
    }

    this._ws.onerror = () => {
      this._onError && this._onError.call(caller)
    }
  }

  send(data) {
    if (this._ws && this._ws.readyState === this._ws.OPEN) {
      let json = JSON.stringify(data)
      this._ws.send(json)
    }
  }

  close() {
    this._ws.close()
  }
}
